import Logger from '../utilities/logger';
import AbstractView from './abstract-view';
import A11yConsentApi from '../a11y-consent-api';

/**
 * A view displaying consent information in a top bar.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export default class TopView extends AbstractView {
  constructor(api: A11yConsentApi, container: HTMLElement) {
    super(api, container);
    Logger.debug('top-view', 'Starting to construct.');
    Logger.debug('top-view', 'Finished constructing.');
  }

  show(): void {
    this.emitter.emit('show', this);
    Logger.info('top-view', 'Show.');
    this.container.ariaHidden = 'false';
    this.emitter.emit('shown', this);
  }

  hide(): void {
    this.emitter.emit('hide', this);
    Logger.info('top-view', 'Hide.');
    this.container.ariaHidden = 'true';
    this.emitter.emit('hidden', this);
  }
}
